module.exports = __webpack_public_path__ + "static/media/_pitcairn-islands.3f234160.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_pitcairn-islands.svg
// module id = 2345
// module chunks = 7